import React from 'react';
import { ApiError } from '../../services/openapi';
import { Col, Row } from 'react-bootstrap';
import { ProductVmcLink } from '../../services/openapi/models/ProductVmcLink';

type ProductProps = {
    product: ProductVmcLink;
    rowColor: string;
    className?: string;
    onDelete?: (vmcId: number, productId: number, locationSelection: string) => void;
    onClick?: () => void;
};

const ProductVmcLinkItem = ({ product, rowColor, className, onDelete, onClick }: ProductProps) => {
    const selectionDescriptionNl = JSON.parse(product.selectionDescription!)["NL"]

    return (
        <>
            <Row
                className={("qvend-table-font " + (className ?? ""))}
                style={{ background: rowColor, color: "black", cursor: 'pointer' }}
                onClick={onClick}
            >                
                <Col md={6} xs={6} className="qvend-table table-column-first">{selectionDescriptionNl}</Col>
                <Col md={5} xs={5} className="qvend-table" title={product.productId.toString()}>{product.productName}</Col>
                <Col md={1} xs={1} className="qvend-table" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0 }}>
                    <button
                        type="button"
                        className="p-0 btn btn-link text-black"
                        style={{ fontFamily: 'Inter, Arial, sans-serif' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (onDelete) onDelete(product.vmcId, product.productId, product.locationSelection);
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-trash"
                            viewBox="0 0 16 16"
                        >
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                        </svg>
                    </button>
                </Col>
            </Row>
        </>
    );
};

export default ProductVmcLinkItem;
